var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"icon":"","small":"","color":"primary"}},[_c('v-icon',{on:{"click":_vm.download}},[_vm._v("mdi-download")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }